/* editor-legend.js — the "Key" row under the editor tools (2026-10-09).
   Markup: snippets/editor-legend.liquid. Styles: wallpaper-configurator-v2.css
   (EDITOR LEGEND block).

   Shows only the rows for marks that are on screen right now. It reads the
   page rather than being called by the editors, so neither editor's code had
   to change: a MutationObserver on the editor (style/class/hidden/data-edit-mode)
   plus input/change events re-check, coalesced to one check per frame.

   Wallpaper configurator (mural / pattern / custom upload):
     crop view shown (Fit to wall, uploads)  -> wall + shade
     #pattern-canvas shown (Seamless, Pattern) -> whole
     state.showPanelDivisions / showRuler, with a valid wall size -> panels / ruler
   Sample kit (custom-sample-editor):
     data-edit-mode="position" (Step 3)  -> wall + shade
     data-edit-mode="sample"   (Step 4)  -> sample + wall-set + sample-shade */
(function () {
  if (window.__acEditorLegend) return;
  window.__acEditorLegend = true;

  function isShown(el) {
    if (!el || !el.isConnected) return false;
    return el.getClientRects().length > 0 && getComputedStyle(el).visibility !== "hidden";
  }

  function configuratorItems(root) {
    var state = root.state || {};
    var crop = root.querySelector("#cropping-area");
    var canvas = root.querySelector("#pattern-canvas");
    var seamless = !!(root.seamless && root.seamless.active);
    var items = [];
    if (isShown(crop) && !seamless) {
      items.push("wall", "shade");
    } else if (isShown(canvas)) {
      items.push("whole");
    } else {
      return items; // nothing loaded yet
    }
    if (state.hasValidDimensions) {
      if (state.showPanelDivisions) items.push("panels");
      if (state.showRuler) items.push("ruler");
    }
    return items;
  }

  function sampleItems(root) {
    if (!isShown(root.querySelector("#cropping-area"))) return [];
    var editRoot = root.querySelector("[data-edit-mode]") || root;
    if (editRoot.dataset.editMode === "sample") return ["sample", "wall-set", "sample-shade"];
    return ["wall", "shade"];
  }

  function setup(legend) {
    var kind = legend.dataset.editorLegend;
    var root = legend.closest(kind === "sample" ? "custom-sample-editor" : "wallpaper-configurator");
    if (!root) return;
    var rows = legend.querySelectorAll("[data-legend-item]");
    var last = null;
    var queued = false;

    function update() {
      queued = false;
      var items = kind === "sample" ? sampleItems(root) : configuratorItems(root);
      var key = items.join(",");
      if (key === last) return;
      last = key;
      for (var i = 0; i < rows.length; i++) {
        rows[i].hidden = items.indexOf(rows[i].dataset.legendItem) === -1;
      }
      legend.hidden = items.length === 0;
    }

    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        // The legend's own hidden flips would otherwise wake the observer again.
        if (!legend.contains(records[i].target)) return queue();
      }
    }).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["style", "class", "hidden", "data-edit-mode"],
    });
    root.addEventListener("input", queue);
    root.addEventListener("change", queue);
    window.addEventListener("resize", queue);
    queue();
  }

  function init() {
    document.querySelectorAll("[data-editor-legend]").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
